import React from "react";
import { useFetchPrincipalWalletData } from "../../Hooks/WalletData/useGetWalletData";

function formatDate(originalDate) {
  const date = new Date(originalDate);
  if (Number.isNaN(date.getTime())) return "N/A";
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  return `${day}/${month}/${year}`;
}

/**
 * Most recent purchase transaction date for a company (principal ledger).
 * Shares react-query cache with GetBalanceComp / LastSellDate for the same companyId.
 */
const GetPurchaseComp = (props) => {
  const companyId = props?.companyId;
  const { data: principal, isLoading, isError } = useFetchPrincipalWalletData(
    companyId,
    { page: 1, limit: 1 }
  );

  if (!companyId) return <div>N/A</div>;
  if (isLoading) return <div>…</div>;
  if (isError) return <div>N/A</div>;

  const lastPurchaseAt = principal?.totals?.lastPurchaseAt;
  return (
    <div>{lastPurchaseAt ? formatDate(lastPurchaseAt) : "N/A"}</div>
  );
};

export default GetPurchaseComp;
